import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="password-visibility"
export default class extends Controller {
  static targets = ["button", "icon", "input"];

  connect() {
    this.updateState();
  }

  toggle(event) {
    event.preventDefault();

    if (!this.hasInputTarget) return;

    this.inputTarget.type =
      this.inputTarget.type === "password" ? "text" : "password";
    this.updateState();
  }

  updateState() {
    if (!this.hasInputTarget || !this.hasButtonTarget || !this.hasIconTarget)
      return;

    const passwordVisible = this.inputTarget.type === "text";

    this.buttonTarget.setAttribute(
      "aria-label",
      passwordVisible ? "Ocultar senha" : "Mostrar senha",
    );
    this.buttonTarget.setAttribute(
      "aria-pressed",
      passwordVisible ? "true" : "false",
    );
    this.buttonTarget.setAttribute(
      "title",
      passwordVisible ? "Ocultar senha" : "Mostrar senha",
    );

    this.iconTarget.classList.toggle("bi-eye", !passwordVisible);
    this.iconTarget.classList.toggle("bi-eye-slash", passwordVisible);
  }
}
